{
  "AllNotifications": "Tutte le notifiche",
  "NoLinkNotification": "Nessun link disponibile per questa notifica",
  "ViewAllAnnouncementTab": "Annunci",
  "ViewallNotificationTab": "Notifiche",
  "preferences": "Modifica preferenze"
}
